import { toast } from "react-toastify";

export interface ToasterConfig {
  position?:
    | "top-left"
    | "top-right"
    | "top-center"
    | "bottom-left"
    | "bottom-right"
    | "bottom-center";
  autoClose?: number;
  hideProgressBar?: boolean;
  closeOnClick?: boolean;
  pauseOnFocusLoss?: boolean;
  draggable?: boolean;
  pauseOnHover?: boolean;
}

export type ToasterColor = "green" | "red" | "yellow" | "info" | "default";

/**
 * Shows a toast notification with customizable color and configuration
 * @param message - The message to display in the toast
 * @param toasterColor - The color/type of the toast (success, error, info, warning, default)
 * @param config - Optional configuration for toast behavior
 */
export const displayToast = (
  message: string,
  toasterColor: ToasterColor = "green",
  config: ToasterConfig = {}
) => {
  const defaultConfig: ToasterConfig = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    ...config,
  };

  switch (toasterColor.toLowerCase()) {
    case "green":
      toast.success(message, defaultConfig);
      break;
    case "red":
      toast.error(message, defaultConfig);
      break;
    case "info":
      toast.info(message, defaultConfig);
      break;
    case "yellow":
      toast.warn(message, defaultConfig);
      break;
    case "default":
    default:
      toast(message, defaultConfig);
      break;
  }
};
